import React from "react";
import { LucideIcon } from "lucide-react";

interface ProcessCardProps {
  icon: LucideIcon;
  number: number;
  title: string;
  description: string;
  isLast?: boolean;
}

export const ProcessCard: React.FC<ProcessCardProps> = ({
  icon: Icon,
  number,
  title,
  description,
  isLast = false,
}) => {
  return (
    <div className="relative flex items-start gap-6 md:gap-8">
      {/* Timeline Line and Icon */}
      <div className="relative flex flex-col items-center flex-shrink-0">
        {/* Icon Circle */}
        <div className="relative z-10 flex items-center justify-center w-10 h-10 rounded-full bg-[#00A3FF]/10 border border-[#00A3FF]/30 transition-transform duration-200 border-dark-bg">
          <Icon className="w-4 h-4 text-[#00A3FF]" strokeWidth={2} />
        </div>

        {/* Step Number Badge */}
        <div className="absolute -top-1.5 -right-1.5 z-20 flex items-center justify-center w-5 h-5 rounded-full bg-dark-bg border border-white/10 text-white/40 text-[10px] font-mono">
          {number}
        </div>

        {/* Vertical Line */}
        {!isLast && (
          <div
            className="absolute top-16 md:top-[4.5rem] w-0.5 h-full bg-gradient-to-b from-[#00A3FF]/50 to-[#00A3FF]/10"
            style={{ height: "calc(100% + 1.25rem)" }}
          ></div>
        )}
      </div>

      {/* Content Card */}
      <div className="group flex-1 border-b border-white/10 pb-6 text-white mb-0">
        <div className="flex items-baseline gap-2 mb-2">
          <h3 className="text-sm font-semibold">{title}</h3>
        </div>
        <p className="text-white/50 leading-relaxed text-sm">{description}</p>
      </div>
    </div>
  );
};
